import React from "react";
import { Headline } from "./brand";
import Button from "./Button";

/**
 * Pre-footer CTA — light band that hands off to the blue footer's wave,
 * so Spectrum Blue appears once per page instead of twice.
 * The wash returns to white at both edges and carries no clipped glows,
 * so the band meets the section above and the wave without a seam.
 */
const CtaBanner = ({
  light,
  bold,
  title,
  description,
  onDownload,
  buttonLabel = "Download Now →",
  id = "download",
}) => {
  return (
    <section
      id={id}
      className="bg-band-wash relative w-full py-16 text-left md:py-20"
    >
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-6 md:px-10">
        <div className="flex flex-col items-start justify-between gap-8 rounded-2xl border border-hairline bg-surface-white p-8 shadow-comfort sm:p-12 md:flex-row md:items-center">
          <div className="max-w-2xl">
            {title ? (
              <h2 className="mb-3 font-headline text-3xl text-spectrum-blue sm:text-4xl">
                {title}
              </h2>
            ) : (
              <Headline
                light={light}
                bold={bold}
                as="h2"
                className="!mb-3 !text-3xl sm:!text-4xl"
              />
            )}
            {description ? (
              <p className="max-w-[560px] font-body text-base text-muted md:text-lg">
                {description}
              </p>
            ) : null}
          </div>

          <div className="shrink-0">
            <Button
              type="button"
              variant="accent"
              size="lg"
              onClick={onDownload}
            >
              {buttonLabel}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
